import React from 'react'

import './Overlay.scss'

interface OverlayProps {
  readonly zIndex?: number
}

const Overlay: React.FC<OverlayProps> = props => {
  return (
    <div
      className="Overlay"
      style={{ zIndex: props.zIndex ?? 100000 }}
    />
  )
}

export default Overlay
